import { Actions, DocumentPreviewAction, InitAction } from './types';
import { Field, Signer } from 'hellospa/components/editor/types';
import { PREPARER } from 'hellospa/components/editor';

export const initPreview = (payload: InitAction['payload']): DocumentPreviewAction => ({
  type: Actions.Init,
  payload: {
    ...payload,
    signers: payload.signers.filter((s) => s.id !== PREPARER),
  },
});

export const setPreviewSigner = (selectedSignerId: Signer['id'] | undefined): DocumentPreviewAction => ({
  type: Actions.SetPreviewSigner,
  payload: selectedSignerId,
});

export const updatePreviewField = (id: Field['id'], updates: Partial<Field>) => ({
  type: Actions.UpdateField,
  payload: { id, updates },
});
